( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('PortCustomService', PortCustomService);

    PortCustomService.$inject = ['$http'];

    function PortCustomService($http) {
        return {
            getPortsByCountry: getPortsByCountry,
            getUsedPorts: getUsedPorts,
            returnSearchPorts: returnSearchPorts
        };

        function returnSearchPorts(query) {
            var url = "api/_search/ports?query=" + query;
            return $http.get(url);
        }

        function getUsedPorts(portType, contractType) {
            var url = "api/ports/filter?portType=" + portType + "&contractType=" + contractType;
            return $http.get(url);
        }

        function getPortsByCountry(country) {
            var url = "api/ports/country/" + country;
            return $http.get(url);
        }
    }
})();
